import React, { useEffect, useState } from 'react'
import { Image, ImageStyle, TouchableOpacity, View } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import moment from 'moment'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Icon, Text } from '@src/components/base'
import { IconSources } from '@src/assets/icons'
import { userPropertiesSelector, userSelector } from '@src/selectors/app'
import { terraProvidersSelector } from '@src/selectors/integrations'
import { useIsDarkMode } from '@src/config/theme'
import { TerraProviderKind } from '@src/types'
import { Feature, useFeatureFlag } from '@src/components'
import { UserPropertyKind } from '@src/types'
import { Analytics, CustomEventTypes } from '@src/config'

export const MfpPromotionCard = () => {
  const styles = useStyleSheet(themedStyle)
  const [mfpPromotionCardDismissed, setMfpPromotionCardDismissed] = useState(false)
  const navigation = useNavigation()
  const providers = useSelector(terraProvidersSelector)
  const provider = providers.find(
    (provider) => provider.providerKind === TerraProviderKind.MyFitnessPal,
  )
  const dispatch = useDispatch()
  const isDarkMode = useIsDarkMode()
  const mfpPromotionEnabled = useFeatureFlag(Feature.MfpPromotion)
  const user = useSelector(userSelector)

  const { mfpPromotionCardDismissalTimestamp } = useSelector(userPropertiesSelector) ?? {}

  const dismiss = () => {
    dispatch({
      type: 'users/upsertUserProperty',
      payload: {
        kind: UserPropertyKind.MfpPromotionCardDismissalTimestamp,
        value: moment().toISOString(),
      },
    })
    setMfpPromotionCardDismissed(true)
    Analytics.track(CustomEventTypes.MfpPromotionCardDismissed, {
      userId: user?.id,
    })
  }

  const goToIntegrationInstructions = () => {
    dispatch({
      type: 'users/upsertUserProperty',
      payload: {
        kind: UserPropertyKind.MfpPromotionCardDismissalTimestamp,
        value: moment().toISOString(),
      },
    })
    setMfpPromotionCardDismissed(true)
    Analytics.track(CustomEventTypes.MfpPromotionCardTapped, {
      userId: user?.id,
    })
    navigation.navigate('MfpInstructions')
  }

  const cardColor = isDarkMode ? '#2A3441' : '#E5EFFD'

  useEffect(() => {
    dispatch({
      type: 'settings/fetchTerraProviders',
    })
  }, [dispatch])

  if (
    !mfpPromotionEnabled ||
    mfpPromotionCardDismissalTimestamp?.value ||
    mfpPromotionCardDismissed ||
    provider?.active
  ) {
    return null
  }

  return (
    <View style={[styles.container, { backgroundColor: cardColor }]}>
      <TouchableOpacity onPress={dismiss} accessibilityLabel="Dismiss">
        <Icon name="x" size={20} />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={goToIntegrationInstructions}
        accessibilityLabel="Go to integration instructions"
        style={styles.innerContainer}
      >
        <Image source={IconSources.myFitnessPal} style={styles.providerIcon as ImageStyle} />
        <View style={styles.textWrapper}>
          <Text type="regular">Integrate with MyFitnessPal to import all your meals</Text>
        </View>
        <Icon name="caret-right" size={20} />
      </TouchableOpacity>
    </View>
  )
}

const themedStyle = StyleService.create({
  container: {
    flexDirection: 'row',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'theme.surface.base',
    padding: 12,
    marginVertical: 12,
    marginHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  innerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    flex: 1,
  },
  textWrapper: {
    flex: 1,
  },
  providerIcon: {
    width: 48,
    height: 48,
    marginRight: 12,
  },
})
